import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Vue from 'vue';
import Stash from './stash';

// Stub the bugsnag reporter in case no API key has been provided
let reporter = {
  metaData: {},
  notify(e) {
    console.error(e);
    console.log(this.metaData);
  },
};

if (process.env.BUGSNAG_API_KEY) {
  const bugsnagClient = Bugsnag.start({
    apiKey: process.env.BUGSNAG_API_KEY,
    onError: function (event) {
      if (event.errors[0].errorMessage.indexOf('__kp__') >= 0) {
        // do not report errors related to kiosk pro
        return false;
      }

      if (Stash.state.store.id) {
        event.addMetadata('store', {
          id: Stash.state.store.id,
          name: Stash.state.store.name,
          wakefern_id: Stash.state.wakefern_id,
        });
      }

      if (Stash.state.fulfiller.id) {
        event.addMetadata('fulfiller', {
          id: Stash.state.fulfiller.id,
          name: Stash.state.fulfiller.name,
        });
      }
    },
    plugins: [new BugsnagPluginVue()],
  });

  Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);

  reporter = bugsnagClient;
}

export default reporter;



// WEBPACK FOOTER //
// ./src/bugsnag.js